/* Native details are the no-JS contract for FAQ, product steps and PDP detail rows. */
(() => {
  if (window.__rizonAccordionTransitions) return;
  window.__rizonAccordionTransitions = true;
  const selector = '.tabs-section details, .product-suggestion details, .main-product details.accordion, .cart-tools--accordion details';
  const states = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function enhance(details) {
    if (states.has(details)) return;
    const summary = details.querySelector(':scope > summary');
    const content = details.querySelector(':scope > .accordion__content,:scope > .product-suggestion__card-content,:scope > .cart-tools__content');
    if (!summary || !content) return;
    const body = document.createElement('div');
    body.className = 'native-accordion__body';
    content.before(body); body.append(content);
    const state = { details, summary, body, content, name: details.getAttribute('name'), expanded: details.open, animation: null };
    states.set(details, state);
    const restoreName = () => { if (state.name !== null) details.setAttribute('name', state.name); };
    const settle = () => {
      state.animation?.cancel(); state.animation = null;
      details.open = state.expanded;
      body.style.removeProperty('height'); body.style.removeProperty('opacity'); body.style.removeProperty('overflow');
      restoreName();
      details.dataset.accordionExpanded = String(state.expanded);
    };
    const transition = expanded => {
      const from = details.open ? body.getBoundingClientRect().height : 0;
      const opacity = details.open ? Number(getComputedStyle(body).opacity) : 0;
      state.animation?.cancel(); state.animation = null;
      state.expanded = expanded;
      details.dataset.accordionExpanded = String(expanded);
      if (reduced.matches || !body.animate) { settle(); return; }
      if (!expanded) details.removeAttribute('name');
      details.open = true;
      const target = expanded ? content.getBoundingClientRect().height : 0;
      state.target = target;
      body.style.overflow = 'hidden';
      state.animation = body.animate([{ height: `${from}px`, opacity }, { height: `${target}px`, opacity: expanded ? 1 : 0 }], {
        duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'
      });
      const animation = state.animation;
      animation.onfinish = () => { if (state.animation === animation) settle(); };
    };
    state.transition = transition;
    const click = event => {
      if (event.defaultPrevented || event.button > 0 || event.target.closest('a,button,input,select,textarea')) return;
      event.preventDefault();
      const expanded = !state.expanded;
      // The reference product steps retain one selected step; ordinary FAQ rows can close.
      if (!expanded && details.closest('.product-suggestion')) return;
      if (expanded && state.name) for (const other of states.values()) {
        if (other !== state && other.name === state.name && other.expanded) other.transition(false);
      }
      transition(expanded);
    };
    const toggle = () => {
      if (state.animation) { if (!details.open) { state.expanded = false; settle(); } return; }
      state.expanded = details.open; details.dataset.accordionExpanded = String(details.open);
    };
    const observer = new ResizeObserver(() => {
      if (state.animation && state.expanded) {
        const height = content.getBoundingClientRect().height;
        if (Math.abs(height - state.target) > .5) transition(true);
      }
    });
    observer.observe(content);
    summary.addEventListener('click', click); details.addEventListener('toggle', toggle);
    details.dataset.accordionExpanded = String(details.open);
    state.cleanup = () => {
      settle(); observer.disconnect(); summary.removeEventListener('click', click); details.removeEventListener('toggle', toggle);
      body.before(content); body.remove(); delete details.dataset.accordionExpanded; states.delete(details);
    };
  }
  const mount = (root = document) => root.querySelectorAll(selector).forEach(enhance);
  const unmount = root => { for (const [details, state] of states) if (root.contains(details)) state.cleanup(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true }); else mount();
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  document.addEventListener('shopify:section:load', event => mount(event.target));
  reduced.addEventListener('change', () => { if (reduced.matches) for (const state of states.values()) state.transition(state.expanded); });
  // Keep partial/fetched render lifecycles local; removed groups cannot retain animation observers.
  const observer = new MutationObserver(records => {
    for (const [details, state] of states) if (!details.isConnected) state.cleanup();
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) {
      if (node.matches(selector)) enhance(node);
      mount(node);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
